var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EmployeeSetupCard',{attrs:{"is-contractor":_vm.isContractor,"is-loading":_vm.isLoadingOnboardingModal},on:{"open-onboarding":_vm.openModal}})}
var staticRenderFns = []

export { render, staticRenderFns }